import React from 'react';
import App from '../App/App';
import {WingBlank} from '../../components';
import ServiceBanner from './ServiceBanner';
import ServiceBreadcrumb from './ServiceBreadcrumb';
import ServiceTitle from './ServiceTitle';
import ServiceList from './ServiceList';
import ServiceMenu from './ServiceMenu';
import {banner, menu, list} from './config';
import './Service.less';

function findPath(nav1, nav2) {
  const item = menu.find(item => item.key === nav1);
  if (item) {
    const item2 = item.children.find(item => item.key === nav2);
    if (item2) {
      return ['综合服务', item.title, item2.title];
    }
  }
  return null;
}

function Content({nav1, nav2, path, menu, list}) {
  return (
    <WingBlank data-role='Content'>
      <ServiceMenu title='综合服务' menu={menu} nav1={nav1} nav2={nav2} />
      <div>
        <ServiceBreadcrumb path={path}/>
        <div>
          <ServiceTitle menu={menu}>{path[2]}</ServiceTitle>
          <ServiceList data={list}/>
        </div>
      </div>
    </WingBlank>
  );
}

const TITLE = {
  hr: '综合服务-人力资源',
  product: '综合服务-产品运营',
  it: '综合服务-IT',
  train: '综合服务-综合培训',
  ecology: '综合服务-生态赋能',
};

function Service({params: {nav1, nav2}}) {
  if (!global.isServer) {
    document.title = TITLE[nav1];
  }
  const path = findPath(nav1, nav2);
  return (
    <App className='Service' key={`${nav1}-${nav2}`}>
      <ServiceBanner data={banner} />
      {path ? <Content {...{nav1, nav2, path, menu, list: list[`${nav1}-${nav2}`]}} /> : null}
    </App>
  );
}

export default Service;



// WEBPACK FOOTER //
// ./src/routes/Service/Service.js